import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TegelModule } from '@scania/tegel-angular-17';
import { DialogService } from 'ng2-bootstrap-modal';
import { ToastrService } from 'ngx-toastr';
import { UtilService } from 'src/app/shared/architecture/services/util.service';
import { ConfirmComponent } from 'src/app/shared/modal/confirm/confirm.component';
import { Status } from 'src/app/shared/models/status.model';
import { StatusService } from 'src/app/shared/services/core/status.service';

@Component({
  selector: 'app-status',
  imports: [TegelModule, CommonModule],
  templateUrl: './status.component.html',
  styleUrl: './status.component.scss'
})
export class StatusComponent implements OnInit {
  status: Status[];
  page = 1;
  searchText = '';
  order = "id";

  constructor(private utilService: UtilService,
              private dialogService: DialogService,
              private statusService: StatusService,
              private toastr: ToastrService) 
  {
    this.status = [];
  }

  ngOnInit(): void {
    this.getAllStatus();
  }

  getAllStatus(){
    this.statusService.get().subscribe((result) => {
      if (result) {
        this.status = result;
      }
    });
  }

  deleteStatus(id: any){
    this.dialogService.addDialog(ConfirmComponent, {
      title: 'Confirmar',
      message: 'Deseja excluir o status ' + id + ' ?'
    }, this.utilService.getModalOptions()).subscribe((resultConfirm) => {
      if (resultConfirm.confirmed) {
        this.statusService.delete(id).subscribe((result) => {
          if (result && !result.hasErrors) {
            let index = 0;
            do {
              index = this.status.findIndex(c => c.id === id);
              if (index > -1) {
                this.status.splice(index, 1);
              }
            } while (index != -1);

            this.toastr.success('Registro excluído.', 'Sucesso');
          }
        });
      }
    });
  }

  // openSaveStatus(status = new Status()) {
  //   this.dialogService.addDialog(SaveStatusComponent, {
  //     status: status
  //   }, this.utilService.getModalOptions()).subscribe((result) => {
  //       if(result && result.success){
  //         this.getAllStatus();
  //         this.toastr.success('Registro salvo.', 'Sucesso');
  //       }
  //   });
  // }


}
